import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const JobApprovalRoutes = [
    {
        "url": `/job-approvals/${hmapPathParamRegex}?brandId&jobId&flowId`,
        "name": "appLayout.harriSH.access-portal.job-approvals",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Job Approvals"
            }
        ],
        "params": {
            ...hmapPathParamConfig,
            brandId: {
                dynamic: true,
            },
            jobId: {
                dynamic: true,
            },
            flowId: {
                dynamic: true,
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/people-platform/people-platform.downgrade.module");
                }
            },
        ]
    }, {
        "url": "/job-approvals/{brandId:[0-9]+}?jobId&flowId",
        "name": "appLayout.harriSH.job-approvals",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            jobId: {
                dynamic: true,
            },
            flowId: {
                dynamic: true,
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/people-platform/people-platform.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=job-approval.routes.js.map